import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import CGU from "../../views/CGU/cgu";
import Close from "@material-ui/icons/Close";
import CustomCard from "../Card/CustomCard";
import {
  searchUser,
  searchUserContent,
} from "../../services/stores/actions/compte";
import { Link, withRouter } from "react-router-dom";
import CardApplication from "../Card/CardApplication";
import StickyFooter from "../Footer/StickyFooter/StickyFooter";

function ModalHome() {
  const [show, setShow] = useState();
  const [pourVous, setpourVous] = useState();
  const [videos, setvideo] = useState();
  const [photos, setphoto] = useState();

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    searchUser(null, 6).then((response) => {
      // console.log("okay", response);
      setpourVous(response.data.data.content);
      // this.setState({
      // 	pourVous: this.spliceArray(response.data.data.content),
      // });
    });
    // searchUserContent().then((response) => {
    //     setvideo(response.data.data.content.filter(c => c.content.category === 'VIDEO'))
    //     setphoto(response.data.data.content.filter(c => c.content.category === 'PHOTO'))
    // });
  }, []);

  return (
    <>
      <button
        onClick={handleShow}
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style={{ fontSize: "12px", padding: "4px 8px" }}
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-litle-vcenter"
        className="m-0 sidenav"
        style={{ width: "75%", margin: "0px !important" }}
      >
        <div
          style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "50",
            cursor: "pointer",
            backgroundColor: "#f7cc2a",
          }}
          onClick={handleClose}
        >
          <Close />
        </div>
        <Modal.Body style={{ overflowY: "scroll" }}>
          <div
            className="mb-3"
            style={{ border: "1px solid gray", padding: "5px" }}
          >
            <Link
              to={`/Photos`}
              className="d-block w-100"
              style={{
                textDecoration: "none",
                color: "#000",
                fontWeight: "600",
              }}
            >
              #PICTURES
            </Link>
          </div>
          <div
            className="mb-3"
            style={{ border: "1px solid gray", padding: "5px" }}
          >
            <Link
              to={`/Videos`}
              className="d-block w-100"
              style={{
                textDecoration: "none",
                color: "#000",
                fontWeight: "600",
              }}
            >
              #VIDEOS
            </Link>
          </div>
          <div
            className="mb-3"
            style={{ border: "1px solid gray", padding: "5px" }}
          >
            <Link
              to={`/Tags`}
              className="d-block w-100"
              style={{
                textDecoration: "none",
                color: "#000",
                fontWeight: "600",
              }}
            >
              #HASHTAGS
            </Link>
          </div>
          <div style={{ border: "1px solid gray", padding: "5px" }}>
            <Link
              to={`/Shopping`}
              className="d-block w-100"
              style={{
                textDecoration: "none",
                color: "#000",
                fontWeight: "600",
              }}
            >
              #SHOPPINGS
            </Link>
          </div>
          <CustomCard label={"Profile"} data={pourVous} />
          {/* <CustomCard label={'Videos'} data={videos} />
                    <CustomCard label={'Photos'} data={photos} /> */}
          {/* <CardApplication /> */}
          <StickyFooter />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalHome;
